import { Injectable } from '@angular/core';

@Injectable()
export class MinMaxService {
  private minDate: Date | number | null;
  private maxDate: Date | number | null;

  setMinDate(minDate: Date | number | null): void {
    this.minDate = minDate;
  }
  setMaxDate(maxDate: Date | number | null): void {
    this.maxDate = maxDate;
  }
  getMinDate(): Date | number | null {
    return this.minDate;
  }
  getMaxDate(): Date | number | null {
    return this.maxDate;
  }
}
